import { ZCDFlex, ZCDTypography } from '@zencity/common-ui';
import classNames from 'classnames';
import React from 'react';
import { OverallSatisfactionScoreQuestion } from 'screens/WidgetGenerator/utils/misc';
import { toPercentString } from 'screens/WidgetGenerator/utils/utilsFunctions';
import { MIN_PERCENTAGE_VALUE, SATISFACTION_BAR_TEST_ID, SATISFACTION_SCORE_BAR_TEST_ID } from '../../../helpers';
import styles from './ServicesBarChartWidgetBar.module.scss';

interface Props {
  score: OverallSatisfactionScoreQuestion['score'];
}

export const ServicesBarChartWidgetBar = (props: Props) => {
  const { score } = props;
  const scoresEntries = Object.entries({
    positive: score.positive,
    neutral: score.neutral,
    negative: score.negative,
  });

  return (
    <div data-testid={SATISFACTION_BAR_TEST_ID} className={styles.root}>
      {scoresEntries.map(([sentiment, sentimentScore], index) => {
        const roundedValue = Math.round(sentimentScore);
        const percentageValue = toPercentString(roundedValue);
        const isPositive = index === 0;
        const isNegative = index === scoresEntries.length - 1;
        const isNeutral = !isPositive && !isNegative;
        const displayValue = roundedValue >= MIN_PERCENTAGE_VALUE;

        return (
          <ZCDFlex
            key={sentiment}
            alignItems="center"
            justifyContent={isNegative ? 'flex-end' : 'flex-start'}
            className={classNames(styles[sentiment])}
            width={percentageValue}
            dataTestid={`${sentiment}${SATISFACTION_SCORE_BAR_TEST_ID}`}
          >
            {displayValue && (
              <ZCDTypography
                variant="t-small"
                className={styles.typography}
                color={isNeutral ? 'zcd-gray-100' : 'zcd-gray-10'}
              >
                {percentageValue}
              </ZCDTypography>
            )}
          </ZCDFlex>
        );
      })}
    </div>
  );
};
